import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useState,
  useRef,
} from "react";
import { Avatar, Box, Stack, Typography, IconButton } from "@mui/material";
import { Images } from "./../../assets/common";
import Slider from "@mui/material/Slider";
import { useHistory } from "react-router-dom";
import VolumeUpRoundedIcon from "@mui/icons-material/VolumeUpRounded";
import VolumeDownRoundedIcon from "@mui/icons-material/VolumeDownRounded";
import VolumeOffRoundedIcon from "@mui/icons-material/VolumeOffRounded";
import PlaylistPlayIcon from "@mui/icons-material/PlaylistPlay";
import PlayQueue from "./../../pages/PlayQueue";

import "./index.scss";
import OutsideClickHandler from "react-outside-click-handler";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  fullName,
  screenWidth,
  truncate,
  getErrorString,
  getUserId,
  isOwnerId,
  putStreamRecord,
  hasPremium,
} from "../../constants/function";
import Loader from "./../../components/Loader";
import notifier from "./../../components/Notifier";
import ApiService from "./../../services/api-service";
import TipPopup from "../TipPopup";
import { getBalance } from "../../asyncAction/asyncBalance";
import { useDispatch, useSelector } from "react-redux";
import AddMusicToPlaylist from "../AddMusicToPlaylist";
import { addSongIndexAction } from "./../../action/songs";
import { updatecount } from "../../action/adv";
import { SocketContext } from "../../context/socket";
import { useTranslation } from "react-i18next";
import Waveform from "./waveform";
import WaveSurferPlayer from "./WaveSurferPlayer";
import FavoriteButton from "../../common/FavoriteButton";
export default function Player({
  songs,
  songIndex,
  all,
  prevSongIndex,
  showAdv,
}) {
  const { t } = useTranslation("common");
  const [seek, setSeek] = React.useState({ started: false, value: null });
  const [showPlaylist, setShowPlaylist] = React.useState(false);
  const [selectedId, setSelectedAlbum] = React.useState();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [showQueue, setShowQueue] = useState(false);
  const [showSmallerQueue, setShowSmallerQueue] = useState(false);

  const [showVolume, setShowVolume] = useState(false);
  const [volume, setVolume] = useState(100);
  const [song, setSong] = useState([]);
  const [currentTime, setCurrentTime] = useState(0);
  const [index, setIndex] = useState(songIndex ? songIndex : 0);
  const history = useHistory();
  const [track, setTrack] = useState(null);
  const [duration, setDuration] = useState(0);
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(false);
  const [repeat, setRepeat] = useState(() => {
    const savedRepeat = localStorage.getItem('playerRepeatMode');
    return savedRepeat ? parseInt(savedRepeat) : 0;
  });
  const { count } = useSelector((state) => state.adv);
  const isPremium = hasPremium();
  const socket = useContext(SocketContext).Socket;
  const [songPlaying, setSongPlaying] = useState(null);
  const [currentPlayTime, setCurrentPlayTime] = useState(0);
  const [newPlayTime, setNewPlayTime] = useState(0);
  const ref = useRef(null);
  const [userSaves, setUserSaves] = useState([]);

  // Listen for global stop event
  useEffect(() => {
    const handleStopAllPlayers = (event) => {
      console.log('[Player] Received stop-all-players event from:', event.detail?.source);
      if (song.length > 0 && song[index] && song[index].track && !song[index].track.paused) {
        // Pause the track
        song[index].track.pause();
        setSongPlaying(false);
        // Also pause any WaveSurfer instance
        const wavesurferPlayer = document.querySelector('.wavesurfer-player');
        if (wavesurferPlayer) {
          wavesurferPlayer.dispatchEvent(new CustomEvent('pause-playback'));
        }
      }
    };
    
    window.addEventListener('stop-all-players', handleStopAllPlayers);
    
    return () => {
      window.removeEventListener('stop-all-players', handleStopAllPlayers);
    };
  }, [song, index]);

  useEffect(() => {
    if (songPlaying == null) return;
    playPause(index);
  }, [songPlaying]);

  useEffect(() => {
    putRecord(
      "seekStart",
      songs[index]?._id,
      songs[index]?.playListId,
      index,
      currentPlayTime,
      new Date().getTime(),
      song[index]?.albumId
    );
    putRecord(
      "seekStop",
      songs[index]?._id,
      songs[index]?.playListId,
      index,
      newPlayTime,
      new Date().getTime(),
      song[index]?.albumId
    );
  }, [newPlayTime]);

  // Stream counting logic for WaveSurfer - triggered by currentPlayTime updates
  useEffect(() => {
    
    if (!song[index] || !duration || duration <= 0 || !songPlaying) {
      return;
    }
    
    // Calculate percentage of song played
    const prg = (currentPlayTime * 100) / duration;
    const streamProgress = song[index]["streamProgress"] || 0;
    
    
    // Debug logging for progress tracking
    if (prg > 0 && Math.floor(prg) % 10 === 0 && Math.floor(prg) !== Math.floor(streamProgress * 100)) {
    }
    
    // Submit stream count at 25% intervals
    if (prg >= 25 && streamProgress < 0.25) {
      submitStreamCount(index, 0.25);
    } else if (prg >= 50 && streamProgress < 0.50) {
      submitStreamCount(index, 0.25);
    } else if (prg >= 75 && streamProgress < 0.75) {
      submitStreamCount(index, 0.25);
    } else if (prg >= 95 && streamProgress < 0.95) {
      submitStreamCount(index, 0.25);
    }
  }, [currentPlayTime, duration, songPlaying, index]);


  useEffect(() => {
  const fetchUserSaves = async () => {
    try {
      const response = await ApiService.GET_SAVES('music');
      setUserSaves(response.data || []);
    } catch (error) {
      console.error('Error fetching user saves:', error);
    }
  };
  fetchUserSaves();
}, []);

  useEffect(() => {
    // console.log(songs);
    const audios = [];
    songs.forEach((s, i) => {
      // Initialize streamProgress for percentage-based counting
      if (!s["streamProgress"]) {
        s["streamProgress"] = 0;
      }
      
      if (s["track"]) {
        // if (i === songs.length - 1) {
        if (!s["track"].paused) {
          // s["track"].pause();
        }
        audios.push(s);
        setSong([...audios]);
        // }
      } else {
        // Create a dummy audio object that doesn't actually play
        // WaveSurfer will handle the actual playback
        const dummyAudio = {
          play: () => console.log("Dummy play - WaveSurfer handles actual playback"),
          pause: () => console.log("Dummy pause - WaveSurfer handles actual pause"),
          volume: 1,
          currentTime: 0,
          duration: 0,
          paused: true
        };
        s["track"] = dummyAudio;
        audios.push(s);
        setSong([...audios]);
      }
    });

    if (songIndex >= 0 && audios.length >= 0) {
      const s = audios;
      if (songIndex === 0) {
        // The dummy audio will log but not actually play
        s[songIndex]["track"].play();
        s[songIndex]["track"]["volume"] = volume / 100;
        if (songPlaying && currentPlayTime < 1) {
          putRecord(
            "start",
            s[songIndex]?._id,
            s[songIndex]?.playListId,
            songIndex,
            currentPlayTime,
            new Date().getTime(),
            s[songIndex]?.albumId
          );
        }
        updateTrack(songIndex, audios);
        setSongPlaying(true);
      }
      if (songIndex > 0) {
        const associationId = new Date().getTime();
        if (s[songIndex - 1]["track"])
          if (showAdv) {
            s[songIndex - 1]["track"].pause();
            if (count % 3 === 0) s[songIndex]["track"].pause();
            else s[songIndex]["track"].play();
          } else if (!showAdv) {
            s[songIndex]["track"].play();
          }
        if (songPlaying) {
          putRecord(
            "start",
            s[songIndex]?._id,
            s[songIndex]?.playListId,
            songIndex,
            currentPlayTime,
            associationId,
            s[songIndex]?.albumId
          );
        }
        s[songIndex]["track"]["volume"] = volume / 100;
        updateTrack(songIndex, audios);
      }

      setIndex(songIndex);
      s[songIndex]["track"].play();
      setSongPlaying(true);
    }
  }, [songs, showAdv]);

  function playPause(i) {
    const associationId = new Date().getTime();

    if (songPlaying) {
      const s = song;
      const t = s[i];
      song[i].track.play();
      setSong([...s]);
      setTrack({ ...t.track });
      putRecord(
        "start",
        song[i]?._id,
        song[i]?.playListId,
        i,
        currentPlayTime,
        associationId,
        song[i]?.albumId
      );
      // updateTrack(i, song);
    } else {
      //   track.pause();
      const s = song;
      const t = s[i];
      song[i].track.pause();
      stop();
      setSong([...s]);
      setTrack({ ...t });
      putRecord(
        "pause",
        song[i]?._id,
        song[i]?.playListId,
        i,
        currentPlayTime,
        associationId,
        song[i]?.albumId
      );
      // updateTrack();
    }
  }
  var myVar;
  const updateTrack = (currentIndex, song) => {
    const t = song[currentIndex].track;

    setTrack({ ...t });
    song[currentIndex]["end"] = false;
    if (t && !t.paused) {
      if (currentIndex === 0)
        song[currentIndex]["track"]["volume"] = volume / 100;
      // else if (currentIndex > 0) {
      //   song[currentIndex]["track"]["volume"] =
      //     song[currentIndex - 1]["track"]["volume"] / 100;
      // }
      t.addEventListener("timeupdate", function fn() {
        const cT = Math.floor(t.currentTime);
        const du = Math.floor(t.duration);
        const prg = (cT * 100) / du;
        // console.log(prg);
        if (du) {
          setDuration(du);
          setCurrentTime(cT);
          setProgress(prg);
        }
        if (prg === 100) {
          // Check if repeat one is enabled
          if (repeat === 2) {
            // Repeat the current song
            t.currentTime = 0;
            t.play();
            setCurrentTime(0);
            setProgress(0);
          } else {
            setCurrentTime(0);
            setProgress(0);
            setDuration(0);
            t.pause();
            // songs[currentIndex]["track"]["currentTime"] = 0;
            // t.currentTime = 0;
            song[currentIndex]["streamed"] = false;
            song[currentIndex]["end"] = true;
            // const audio = new Audio(song[currentIndex].fileId.filePath);
            // t["track"] = audio;
            // handleChange(true, 0);
            // t.removeEventListener("timeupdate", fn);
          }
        }
        // Track stream progress at 25% intervals
        const streamProgress = song[currentIndex]["streamProgress"] || 0;
        
        // Debug logging for progress tracking
        if (prg > 0 && Math.floor(prg) % 10 === 0 && Math.floor(prg) !== Math.floor(streamProgress * 100)) {
          console.log(`🎵 PROGRESS DEBUG: ${prg}% reached, streamProgress: ${streamProgress}, paused: ${t.paused}`);
        }
        
        if (prg >= 25 && streamProgress < 0.25 && !t.paused) {
          console.log('🎵 STREAM COUNT: 25% reached for song:', song[currentIndex].title);
          submitStreamCount(currentIndex, 0.25);
        } else if (prg >= 50 && streamProgress < 0.50 && !t.paused) {
          console.log('🎵 STREAM COUNT: 50% reached for song:', song[currentIndex].title);
          submitStreamCount(currentIndex, 0.25);
        } else if (prg >= 75 && streamProgress < 0.75 && !t.paused) {
          console.log('🎵 STREAM COUNT: 75% reached for song:', song[currentIndex].title);
          submitStreamCount(currentIndex, 0.25);
        } else if (prg >= 95 && streamProgress < 0.95 && !t.paused) {
          console.log('🎵 STREAM COUNT: 95% reached for song:', song[currentIndex].title);
          submitStreamCount(currentIndex, 0.25);
        }

        if (
          all &&
          song[currentIndex]["end"] === true &&
          currentIndex < song.length - 1
        ) {
          // const newIndex = currentIndex + 1;
          // setIndex(newIndex);
          // song[newIndex]["track"].play();
          // updateTrack(newIndex, song);
          t.removeEventListener("timeupdate", fn);
          // dispatch(updatecount(count + 1));
          handleNext("next", currentIndex, true);
        }
        if (
          all &&
          song[currentIndex]["end"] === true &&
          currentIndex === song.length - 1
        ) {
          // At the end of playlist
          if (repeat === 1 && song.length > 0) {
            // Repeat all is enabled - go back to first song
            t.removeEventListener("timeupdate", fn);
            // Stop current song
            putRecord(
              "stop",
              song[currentIndex]?._id,
              song[currentIndex]?.playListId,
              currentIndex,
              song[currentIndex].track.currentTime,
              new Date().getTime(),
              song[currentIndex]?.albumId
            );
            t.currentTime = 0;
            t.removeEventListener("timeupdate", fn);
            // Start from the beginning of the playlist
            dispatch({ type: "ADD_SONG_INDEX", payload: 0 });
            // Play first song after a short delay to ensure state update
            setTimeout(() => {
              song[0]["track"].play();
              updateTrack(0, song);
            }, 100);
          } else {
            putRecord(
              "stop",
              song[currentIndex]?._id,
              song[currentIndex]?.playListId,
              currentIndex,
              song[currentIndex].track.currentTime,
              new Date().getTime(),
              song[currentIndex]?.albumId
            );
            t.currentTime = 0;
            setTrack({ ...t });
          }
        }
        // if (repeat === 1 && prg === 100 && t.pause()) {
        //   playPause(songIndex);
        // }
      });
      // t.play();
    }
  };
  const submitStreamCount = (index, amount) => {
    const tempSong = [...song];
    const currentProgress = tempSong[index]["streamProgress"] || 0;
    tempSong[index]["streamProgress"] = currentProgress + amount;
    setSong(tempSong);
    
    console.log(`🎵 STREAM COUNT: Submitting ${amount} (total: ${currentProgress + amount})`);
    
    addStream(
      song[index]["_id"],
      song[index]["playListId"],
      song[index]["albumId"],
      amount
    );
  };

  const addStream = async (songId, playListId, albumId, streamCount = 1) => {
    try {
      const payload = {
        userId: getUserId(),
        musicId: songId,
        inPlaylist: playListId ? true : false,
        streamCount: streamCount,
      };
      if (playListId) payload["playlistId"] = playListId;
      if (albumId) payload["albumId"] = albumId;
      
      console.log("🎵 STREAM COUNT: Calling streaming/add endpoint:", payload);
      const response = await ApiService.STREAM_ADD(payload);
      console.log("🎵 STREAM COUNT: API Response:", response);
      
      if (response?.result?.remainingBalance !== undefined) {
        localStorage.setItem(
          "streamingBalance",
          response.result.remainingBalance
        );
        console.log(`💰 Stream deducted! New balance: ${response.result.remainingBalance}`);
      }
    } catch (error) {
      console.error("❌ Failed to deduct stream:", getErrorString(error));
    }
  };

  const repeatSong = () => {
    // Cycle through repeat modes: 0 (off) -> 1 (repeat all) -> 2 (repeat one) -> 0
    const nextRepeatMode = (repeat + 1) % 3;
    setRepeat(nextRepeatMode);
    localStorage.setItem('playerRepeatMode', nextRepeatMode);
  };

  function stop() {
    setInterval(myVar);
  }

  const handleEnd = (e, value) => {
    handleSeek(value, true);
  };
  const handleSeek = React.useCallback(
    (value, end) => {
      const t = songs[index]["track"];

      if (t.paused) return;
      if (!seek.started && !end) {
        putRecord(
          "seekStart",
          songs[index]?._id,
          songs[index]?.playListId,
          index,
          t.currentTime,
          new Date().getTime(),
          song[index]?.albumId
        );
        setSeek((seek) => {
          return { ...seek, started: true, value: value };
        });
      } else if (seek.started && end) {
        putRecord(
          "seekStop",
          songs[index]?._id,
          songs[index]?.playListId,
          index,
          t.currentTime,
          new Date().getTime(),
          song[index]?.albumId
        );
        const obj = { started: false, value: null };
        setSeek({ ...obj });
      }
    },
    [seek.value]
  );
  const handleChange = (newProgress) => {
    handleSeek(newProgress, false);
    const t = songs[index]["track"];

    const cDu = (duration * newProgress) / 100;
    t.currentTime = cDu;
    setTrack({ ...t });
    setCurrentTime(newProgress);
    // putRecord(
    //   "seekStart",
    //   songs[index]._id,
    //   songs[index].playListId,
    //   index,
    //   t.currentTime,
    //   new Date().getTime()
    // );
  };

  const handleNext = (type, currentIndex, self) => {
    if (type) {
      const s = songs; //temporary song array
      // s[currentIndex].track.pause();
      // s[currentIndex]["track"]["currentTime"] = 0;
      setTrack({ ...s[currentIndex].track });
      if (type === "next") {
        let i = currentIndex + 1;
        // console.log(s[currentIndex].track.currentTime, "::T::");
        if (
          (!self && s[currentIndex].track.currentTime > 30) ||
          s[currentIndex].track.currentTime > 30
        ) {
          // dispatch(updatecount(count + 1));
        }

        putRecord(
          "stop",
          s[currentIndex]?._id,
          s[currentIndex]?.playListId,
          currentIndex,
          s[currentIndex].track.currentTime,
          new Date().getTime(),
          s[currentIndex]?.albumId
        );
        s[currentIndex]["track"]["currentTime"] = 0;
        putRecord(
          "next",
          s[i]?._id,
          s[i]?.playListId,
          i,
          s[i].track.currentTime,
          new Date().getTime(),
          s[i]?.albumId
        );
        setIndex((indx) => (indx = i));

        // s[i]["track"].play();
        s[i]["track"]["volume"] =
          (s[currentIndex]["track"]["volume"] * 100) / 100;
        dispatch(addSongIndexAction(i));
        // updateTrack(i, s);
        setSong([...s]);
        setTrack({ ...s[i]["track"] });
      }

      if (type === "prev") {
        if (s[currentIndex].track.currentTime > 30) {
          // dispatch(updatecount(count + 1));
        }
        let i = currentIndex - 1;
        putRecord(
          "stop",
          s[currentIndex]?._id,
          s[currentIndex]?.playListId,
          currentIndex,
          s[currentIndex].track.currentTime,
          new Date().getTime(),
          s[currentIndex]?.albumId
        );
        s[currentIndex]["track"]["currentTime"] = 0;
        putRecord(
          "previous",
          s[i]?._id,
          s[i]?.playListId,
          i,
          s[i].track.currentTime,
          new Date().getTime(),
          s[i]?.albumId
        );
        setIndex((indx) => (indx = i));

        // s[i].track.play();
        s[i]["track"]["volume"] =
          (s[currentIndex]["track"]["volume"] * 100) / 100;
        dispatch(addSongIndexAction(i));
        // updateTrack(i, s);
        setSong([...s]);
        setTrack({ ...s[i].track });
      }
    }
  };
  const [size, setSize] = useState();
  useLayoutEffect(() => {
    function updateSize() {
      setSize(screenWidth());
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  const handleVolume = (value) => {
    setVolume(value);
    // if (song[index].track) {
    //   const s = song; //temporary song array
    //   s[index].track.volume = value / 100;
    //   setTrack({ ...s[index].track });
    // }
  };

  const handleSaveToggle = (itemId, isSaved) => {
  if (isSaved) {
    setUserSaves([...userSaves, itemId]);
  } else {
    setUserSaves(userSaves.filter(id => id !== itemId));
  }
};
  const handleClose = async (amount, id, type, currency) => {
    if (amount) {
      try {
        const payload = {
          id: id,
          tipAmount: amount,
          type: type,
          currency: currency,
        };
        setLoading(true);
        const response = await ApiService.TIP_ARTIST(payload);
        setLoading(false);
        notifier.success(response["result"]);
        setOpen(false);
        dispatch(getBalance());
      } catch (error) {
        setLoading(false);
        notifier.error(getErrorString(error));
      }
    } else {
      setOpen(false);
    }
  };
  function randomIntFromInterval(min, max) {
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  const reditectToProfile = (curentSong) => {
    if (typeof curentSong["creatorId"] === "string")
      history.push(`/app/ArtistProfile/${song[index]["creatorId"]}`);
    else if (typeof curentSong["owner"] === "string")
      history.push(`/app/ArtistProfile/${song[index]["owner"]}`);
    else if (typeof curentSong["uploader"] === "string")
      history.push(`/app/ArtistProfile/${song[index]["uploader"]}`);
    else if (typeof curentSong["owner"] === "object")
      history.push(`/app/ArtistProfile/${song[index]["owner"]["_id"]}`);
    else if (typeof curentSong["uploader"] === "object")
      history.push(`/app/ArtistProfile/${song[index]["uploader"]["_id"]}`);
  };

  const getName = () => {
    return song[index]["artist"]
      ? song[index]["artist"]
      : fullName(
          song[index]["owner"]
            ? song[index]["owner"]
            : song[index]["uploader"]
            ? song[index]["uploader"]
            : ""
        );
  };

  const putRecord = (
    event,
    musicId,
    playlistId,
    index,
    timeInSong,
    associationId,
    albumId
  ) => {
    const userId = getUserId();
    const payload = {
      eventType: event,
      timestamp: new Date().getTime(),
      userId: userId,
      musicId: musicId,
      playlistId: playlistId,
      livestreamId: null,
      songDetails: songs[index],
      timeInSong: timeInSong,
      associationId: associationId,
      sessionId: "sessionId",
      albumId: albumId,
    };
    putStreamRecord(payload);
  };
  // React.useEffect(() => {
  //   socket.on("show-ad", (data) => {
  //     const userId = getUserId();
  //     if (data[0] === userId && !count) {
  //       // playPause(songIndex);
  //       dispatch(updatecount(1));
  //     }
  //   });
  // }, [socket]);

  return (
    <Box>
      {song.length > 0 ? (
        <Box className="__player" onClick={() => setShowVolume(false)}>
          <Box sx={{ position: "relative" }}>
            {song[index] ? (
              <Stack
                direction="column"
                style={{ padding: "10px 18px" }}
                gap={1}
              >
                <Stack direction="row" className="__player_box_top">
                  <Stack
                    className="__player_box_top_left"
                    sx={{ justifyContent: "flex-start" }}
                    direction="row"
                  >
                    <Avatar
                      sx={{
                        marginRight: "10px",
                        height: "30px",
                        width: "30px",
                      }}
                      src={
                        song[index]["thumbnailImg"]
                          ? song[index]["thumbnailImg"]["filePath"]
                          : Images.rectangle
                      }
                    />
                    {/* Song details */}
                    <Stack direction="column" marginRight="auto">
                      <Typography
                        title={song[index]["title"]}
                        variant="body1"
                        style={{ width: "max-content", fontSize: "0.9rem" }}
                        color="primary"
                        className="_cp text-capitalize"
                        onClick={() =>
                          song[index]["nftId"]
                            ? history.push(
                                `/app/SongDetail/${song[index]["nftId"]}`
                              )
                            : history.push(
                                `/app/SongDetails/${song[index]["_id"]}`
                              )
                        }
                      >
                        {size < 600
                          ? truncate(song[index]["title"], 15)
                          : size > 600
                          ? truncate(song[index]["title"], 25)
                          : song[index]["title"]}
                      </Typography>
                      <Stack
                        direction="row"
                        className="__artist_name"
                        style={{
                          overflowY: "scroll",
                          width: "120px",
                          gap: "5px",
                        }}
                      >
                        {song[index]?.artistData ? (
                          song[index]?.artistData?.length > 1 ? (
                            song[index]?.artistData?.map((a, aIndex) => (
                              <Typography
                                variant="body2"
                                className="_cp"
                                onClick={() =>
                                  history.push(`/app/ArtistProfile/${a.uId}`)
                                }
                                key={aIndex}
                                style={{
                                  whiteSpace: "nowrap",
                                  fontSize: ".725rem",
                                }}
                              >
                                {a?.displayArtistName}
                                {aIndex === song[index]["artistData"].length - 1
                                  ? ""
                                  : ","}
                              </Typography>
                            ))
                          ) : (
                            song[index]?.artistData.map((a, aIndex) => (
                              <Typography
                                variant="body2"
                                className="_cp"
                                onClick={() =>
                                  history.push(`/app/ArtistProfile/${a.uId}`)
                                }
                                key={aIndex}
                                style={{
                                  whiteSpace: "nowrap",
                                  fontSize: ".725rem",
                                }}
                              >
                                {a?.displayArtistName}
                              </Typography>
                            ))
                          )
                        ) : (
                          <Typography
                            variant="body2"
                            className="_cp"
                            onClick={() => reditectToProfile(song[index])}
                          >
                            {size < 600
                              ? truncate(
                                  fullName(
                                    song[index]["artist"]
                                      ? song[index]["artist"]
                                      : song[index]["uploader"]
                                  ),
                                  9
                                )
                              : fullName(
                                  song[index]["artist"]
                                    ? song[index]["artist"]
                                    : typeof song[index]["uploader"] ===
                                      "object"
                                    ? song[index]["uploader"]
                                    : ""
                                )}
                          </Typography>
                        )}
                      </Stack>
                    </Stack>
                  </Stack>
                  <Stack
                    className="__player_box_top_right"
                    sx={{ justifyContent: "flex-end" }}
                    alignItems="center"
                    direction="row"
                  >
                    <IconButton
                      onClick={repeatSong}
                      title={
                        repeat === 0
                          ? t("repeat_off")
                          : repeat === 1
                          ? t("repeat_all")
                          : t("repeat_one")
                      }
                    >
                      <img
                        src={
                          repeat === 2
                            ? Images.repeat_one
                            : repeat === 1
                            ? Images.repeat_active
                            : Images.repeat
                        }
                        alt="repeat"
                        className="w24 h24"
                        style={{
                          opacity: repeat > 0 ? 1 : 0.6,
                        }}
                      />
                    </IconButton>
                    <Box sx={{ position: "relative", display: "flex" }}>
                      {showSmallerQueue ? (
                        <OutsideClickHandler
                          onOutsideClick={() => {
                            setShowSmallerQueue(false);
                          }}
                        >
                          <Box className="__player_queue">
                            <PlayQueue
                              handleClose={(e) => {
                                if (e === null) song[index].track.pause();
                                setShowSmallerQueue(false);
                              }}
                              onRedirect={(path) => {
                                setShowQueue(false);
                                history.push(path);
                              }}
                              playingIndex={index}
                              handleSelectedId={(id) => {
                                setSelectedAlbum(id);
                              }}
                              handleShowPlaylist={(show) => {
                                setShowPlaylist(show);
                              }}
                              currentPlayTime={currentPlayTime}
                            />
                          </Box>
                        </OutsideClickHandler>
                      ) : null}
                      <IconButton
                        title={t("view_queue")}
                        onClick={() => {
                          setShowVolume(false);
                          setShowSmallerQueue(!showSmallerQueue);
                        }}
                      >
                        {/* <PlaylistPlayIcon color="default" /> */}
                        <img
                          src={Images.white_stream}
                          alt=""
                          className="w24 h24"
                        />
                      </IconButton>
                      <IconButton
                        title={t("dropMenu.m3")}
                        onClick={() => {
                          setSelectedAlbum(song[index]["_id"]);
                          setShowPlaylist(true);
                        }}
                      >
                        <img
                          src={Images.playlist_add}
                          alt="add to studio"
                          className="w24 h20"
                        />
                      </IconButton>
                    </Box>
                    {(song[index]["owner"] || song[index]["uploader"]) &&
                    !isOwnerId(
                      song[index]["owner"]
                        ? song[index]["owner"]["_id"]
                        : song[index]["uploader"] &&
                          song[index]["uploader"]["_id"]
                        ? song[index]["uploader"]["_id"]
                        : typeof song[index]["uploader"] === "string"
                        ? song[index]["uploader"]
                        : ""
                    ) ? (
                      <Stack
                        direction="row"
                        alignItems="center"
                        gap="5px"
                        padding="8px"
                        onClick={() => setOpen(!open)}
                        className="_cp"
                        title="Tip song"
                      >
                        <img
                          style={{ width: "24px" }}
                          src={Images.tip_player}
                          alt="tip_player"
                        />
                        {/* <Typography
                          color="primary"
                          className="fs-13 nowrap canceled _cp"
                        >
                          Send Tip
                        </Typography> */}
                      </Stack>
                    ) : null}
                    <InfoOutlinedIcon
                      title="View song information"
                      className="_cp"
                      color="default"
                      onClick={() =>
                        song[index]["nftId"]
                          ? history.push(
                              `/app/SongDetail/${song[index]["nftId"]}`
                            )
                          : history.push(
                              `/app/SongDetails/${song[index]["_id"]}`
                            )
                      }
                    />
                    {song[index]?.nftId && song[index]?.platform ? (
                      song[index]?.platform === "Hedera" ? (
                        <img
                          onClick={() =>
                            history.push(`/app/NftDetail/${song[index]?.nftId}`)
                          }
                          title="View nft details"
                          style={{
                            width: "24px",
                            padding: "5px",
                            cursor: "pointer",
                          }}
                          src={Images.hbar_2}
                          alt=""
                        />
                      ) : song[index]?.platform === "Polygon" ? (
                        <img
                          onClick={() =>
                            history.push(`/app/NftDetail/${song[index]?.nftId}`)
                          }
                          title="View nft details"
                          style={{
                            width: "24px",
                            padding: "5px",
                            cursor: "pointer",
                          }}
                          src={Images.polygoon2}
                          alt=""
                        />
                      ) : song[index]?.platform === "Siki" ? (
                        <img
                          onClick={() =>
                            history.push(`/app/NftDetail/${song[index]?.nftId}`)
                          }
                          title="View nft details"
                          style={{
                            width: "24px",
                            padding: "5px",
                            cursor: "pointer",
                          }}
                          src={Images.sikitoken}
                          alt="siki"
                        />
                      ) : (
                        <img
                          onClick={() =>
                            history.push(`/app/NftDetail/${song[index]?.nftId}`)
                          }
                          title="View nft details"
                          style={{
                            width: "24px",
                            padding: "5px",
                            cursor: "pointer",
                          }}
                          src={Images.near_nft}
                          alt=""
                        />
                      )
                    ) : null}
                  </Stack>
                </Stack>
                <Stack direction="row" className="__player_box">
                  <Stack
                    className="__player_box_left"
                    sx={{ justifyContent: "flex-start" }}
                    direction="row"
                  >
                    <Avatar
                      sx={{ marginRight: "10px" }}
                      src={
                        song[index]["thumbnailImg"]
                          ? song[index]["thumbnailImg"]["filePath"]
                          : Images.rectangle
                      }
                    />
                    {/* Song details */}
                    <Stack direction="column" marginRight="auto">
                      <Typography
                        title={song[index]["title"]}
                        variant="body1"
                        style={{ width: "max-content" }}
                        color="primary"
                        className="_cp text-capitalize"
                        onClick={() =>
                          song[index]["nftId"]
                            ? history.push(
                                `/app/SongDetail/${song[index]["nftId"]}`
                              )
                            : history.push(
                                `/app/SongDetails/${song[index]["_id"]}`
                              )
                        }
                      >
                        {size < 600
                          ? truncate(song[index]["title"], 15)
                          : size > 600
                          ? truncate(song[index]["title"], 25)
                          : song[index]["title"]}
                      </Typography>
                      <Stack
                        direction="row"
                        style={{
                          overflowY: "scroll",
                          width: "191px",
                          gap: "5px",
                        }}
                      >
                        {song[index]?.artistData ? (
                          song[index]?.artistData?.length > 1 ? (
                            song[index]?.artistData?.map((a, aIndex) => (
                              <Typography
                                variant="body2"
                                className="_cp"
                                onClick={() =>
                                  history.push(`/app/ArtistProfile/${a.uId}`)
                                }
                                key={aIndex}
                                style={{ whiteSpace: "nowrap" }}
                              >
                                {a?.displayArtistName}
                                {aIndex === song[index]["artistData"].length - 1
                                  ? ""
                                  : ","}
                              </Typography>
                            ))
                          ) : (
                            song[index]?.artistData.map((a, aIndex) => (
                              <Typography
                                variant="body2"
                                className="_cp"
                                onClick={() =>
                                  history.push(`/app/ArtistProfile/${a.uId}`)
                                }
                                key={aIndex}
                                style={{
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {a?.displayArtistName}
                              </Typography>
                            ))
                          )
                        ) : (
                          <Typography
                            variant="body2"
                            className="_cp"
                            onClick={() => reditectToProfile(song[index])}
                          >
                            {size < 600
                              ? truncate(
                                  fullName(
                                    song[index]["artist"]
                                      ? song[index]["artist"]
                                      : song[index]["uploader"]
                                  ),
                                  9
                                )
                              : fullName(
                                  song[index]["artist"]
                                    ? song[index]["artist"]
                                    : typeof song[index]["uploader"] ===
                                      "object"
                                    ? song[index]["uploader"]
                                    : ""
                                )}
                          </Typography>
                        )}
                      </Stack>
                    </Stack>
                  </Stack>




                  <WaveSurferPlayer
                    showAdv={showAdv}
                    volume={volume}
                    url={song[index].fileId.filePath}
                    sampleData={song[index].sampleData}
                    handlePlay={(value) => {
                      setSongPlaying(value);
                    }}
                    handleCurrentTime={(value) => {
                      setCurrentPlayTime(value);
                    }}
                    handleDuration={(value) => {
                      setDuration(value);
                    }}
                    handlePrev={() =>
                      songs.length > 1 && index >= 1
                        ? handleNext("prev", index)
                        : handleNext()
                    }
                    handleNext={() =>
                      songs.length > 1 && index < songs.length - 1
                        ? handleNext("next", index)
                        : handleNext()
                    }
                    handleEnd={() => {
                      if (repeat === 2) {
                        // Repeat one - restart current song
                        const s = song;
                        s[index]["track"].currentTime = 0;
                        s[index]["track"].play();
                        setSong([...s]);
                      } else if (songs.length > 1 && index < songs.length - 1) {
                        // Play next song
                        handleNext("next", index);
                      } else if (repeat === 1 && songs.length > 0) {
                        // Repeat all - go back to first song
                        const s = song;
                        s[index]["track"].pause();
                        s[index]["track"].currentTime = 0;
                        // Use Redux action to update index
                        dispatch({ type: "ADD_SONG_INDEX", payload: 0 });
                        // Play first song after a short delay to ensure state update
                        setTimeout(() => {
                          s[0]["track"].play();
                          updateTrack(0, s);
                        }, 100);
                      } else {
                        // Stop playback
                        handleNext();
                      }
                    }}
                    handleSeek={(value) => {
                      setNewPlayTime(value);
                    }}
                  />

                  <Stack
                    ref={ref}
                    className="__player_box_right"
                    sx={{ justifyContent: "flex-end", width: 0.3 }}
                    alignItems="center"
                    direction="row"
                  >
                    <IconButton
                      onClick={repeatSong}
                      title={
                        repeat === 0
                          ? t("repeat_off")
                          : repeat === 1
                          ? t("repeat_all")
                          : t("repeat_one")
                      }
                    >
                      <img
                        src={
                          repeat === 2
                            ? Images.repeat_one
                            : repeat === 1
                            ? Images.repeat_active
                            : Images.repeat
                        }
                        alt="repeat"
                        className="w24 h24"
                        style={{
                          opacity: repeat > 0 ? 1 : 0.6,
                        }}
                      />
                    </IconButton>
                    <FavoriteButton
                      itemId={song[index]?._id}
                      itemType="music"
                      userSaves={userSaves}
                      onSaveToggle={handleSaveToggle}
                      size={24}
                    />
                    <Box sx={{ position: "relative" }}>
                      {showVolume ? (
                        <OutsideClickHandler
                          onOutsideClick={() => {
                            setShowVolume(false);
                          }}
                        >
                          <Box className="__volume">
                            <Slider
                              aria-label="Volume"
                              orientation="vertical"
                              value={volume}
                              onChange={(e, value) => handleVolume(value)}
                              sx={{
                                padding: 0,
                                width: "2px",
                                "& .MuiSlider-thumb": {
                                  width: 8,
                                  height: 8,
                                  transition:
                                    "0.3s cubic-bezier(.47,1.64,.41,.8)",
                                  "&:before": {
                                    boxShadow: "0 2px 12px 0 rgba(0,0,0,0.4)",
                                  },
                                },
                              }}
                            />
                          </Box>
                        </OutsideClickHandler>
                      ) : null}
                      <IconButton
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowQueue(false);
                          if (volume === 0) {
                            handleVolume(50);
                            setShowVolume(true);
                          } else {
                            setShowVolume(!showVolume);
                          }
                        }}
                      >
                        {song[index]["track"] && volume === 0 ? (
                          <VolumeOffRoundedIcon
                            className={
                              showVolume ? "__volume_active" : "__volume_button"
                            }
                          />
                        ) : song[index]["track"] &&
                          volume > 0 &&
                          volume < 50 ? (
                          <VolumeDownRoundedIcon
                            className={
                              showVolume ? "__volume_active" : "__volume_button"
                            }
                          />
                        ) : (
                          <VolumeUpRoundedIcon
                            className={
                              showVolume ? "__volume_active" : "__volume_button"
                            }
                          />
                        )}
                      </IconButton>
                    </Box>
                    <Box sx={{ position: "relative", display: "flex" }}>
                      {showQueue ? (
                        <OutsideClickHandler
                          onOutsideClick={() => {
                            setShowQueue(false);
                          }}
                        >
                          <Box className="__player_queue">
                            <PlayQueue
                              handleClose={(e) => {
                                if (e === null) song[index].track.pause();
                                setShowQueue(false);
                              }}
                              onRedirect={(path) => {
                                setShowQueue(false);
                                history.push(path);
                              }}
                              playingIndex={index}
                              handleSelectedId={(id) => {
                                setSelectedAlbum(id);
                              }}
                              handleShowPlaylist={(show) => {
                                setShowPlaylist(show);
                              }}
                              currentPlayTime={currentPlayTime}
                            />
                          </Box>
                        </OutsideClickHandler>
                      ) : null}
                      <IconButton
                        title={t("view_queue")}
                        onClick={() => {
                          setShowVolume(false);
                          setShowQueue(!showQueue);
                        }}
                      >
                        {/* <PlaylistPlayIcon color="default" /> */}
                        <img
                          src={Images.white_stream}
                          alt=""
                          className="w24 h24"
                        />
                      </IconButton>
                      <IconButton
                        title={t("dropMenu.m3")}
                        onClick={() => {
                          setSelectedAlbum(song[index]["_id"]);
                          setShowPlaylist(true);
                        }}
                      >
                        <img
                          src={Images.playlist_add}
                          alt="add to studio"
                          className="w24 h20"
                        />
                      </IconButton>
                    </Box>
                    {(song[index]["owner"] || song[index]["uploader"]) &&
                    !isOwnerId(
                      song[index]["owner"]
                        ? song[index]["owner"]["_id"]
                        : song[index]["uploader"] &&
                          song[index]["uploader"]["_id"]
                        ? song[index]["uploader"]["_id"]
                        : typeof song[index]["uploader"] === "string"
                        ? song[index]["uploader"]
                        : ""
                    ) ? (
                      <Stack
                        direction="row"
                        alignItems="center"
                        gap="5px"
                        padding="8px"
                        onClick={() => setOpen(!open)}
                        className="_cp"
                        title="Tip song"
                      >
                        <img
                          style={{ width: "24px" }}
                          src={Images.tip_player}
                          alt="tip_player"
                        />
                        <Typography
                          color="primary"
                          className="fs-13 nowrap canceled _cp"
                        >
                          Send Tip
                        </Typography>
                      </Stack>
                    ) : null}
                    <InfoOutlinedIcon
                      title="View song information"
                      className="_cp"
                      color="default"
                      onClick={() =>
                        song[index]["nftId"]
                          ? history.push(
                              `/app/SongDetail/${song[index]["nftId"]}`
                            )
                          : history.push(
                              `/app/SongDetails/${song[index]["_id"]}`
                            )
                      }
                    />
                    {song[index]?.nftId && song[index]?.platform ? (
                      song[index]?.platform === "Hedera" ? (
                        <img
                          onClick={() =>
                            history.push(`/app/NftDetail/${song[index]?.nftId}`)
                          }
                          title="View nft details"
                          style={{
                            width: "24px",
                            padding: "5px",
                            cursor: "pointer",
                          }}
                          src={Images.hbar_2}
                          alt=""
                        />
                      ) : song[index]?.platform === "Polygon" ? (
                        <img
                          onClick={() =>
                            history.push(`/app/NftDetail/${song[index]?.nftId}`)
                          }
                          title="View nft details"
                          style={{
                            width: "24px",
                            padding: "5px",
                            cursor: "pointer",
                          }}
                          src={Images.polygoon2}
                          alt=""
                        />
                      ) : song[index]?.platform === "Siki" ? (
                        <img
                          onClick={() =>
                            history.push(`/app/NftDetail/${song[index]?.nftId}`)
                          }
                          title="View nft details"
                          style={{
                            width: "24px",
                            padding: "5px",
                            cursor: "pointer",
                          }}
                          src={Images.sikitoken}
                          alt="siki"
                        />
                      ) : (
                        <img
                          onClick={() =>
                            history.push(`/app/NftDetail/${song[index]?.nftId}`)
                          }
                          title="View nft details"
                          style={{
                            width: "24px",
                            padding: "5px",
                            cursor: "pointer",
                          }}
                          src={Images.near_nft}
                          alt=""
                        />
                      )
                    ) : null}
                  </Stack>
                </Stack>
              </Stack>
            ) : null}
          </Box>
        </Box>
      ) : null}
      {open ? (
        <TipPopup
          artist={getName()}
          id={song[index]["_id"]}
          open={open}
          isArtist={false}
          handleClose={handleClose}
        />
      ) : null}
      {showPlaylist ? (
        <AddMusicToPlaylist
          musicId={selectedId}
          open={showPlaylist}
          handleClose={() => setShowPlaylist(false)}
        />
      ) : null}
      {loading ? <Loader /> : null}
    </Box>
  );
}
